import { AppRoute } from '@shared/config'

interface ButtonTaskCancelReturn {
  handleClick: () => void
}

export const useButtonTaskCancel = (): ButtonTaskCancelReturn => {
  const handleClick = (): void => {
    void navigateTo(AppRoute.TasksKanbanSupport)
  }

  return {
    handleClick,
  }
}